export default function(selector) {
  return function() {
    return this.matches(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/matcher.js
// module id = 639
// module chunks = 0